import { render, staticRenderFns } from "./ProjectFolderDefaultTable.vue?vue&type=template&id=eb1c892a&"
import script from "./ProjectFolderDefaultTable.vue?vue&type=script&lang=ts&"
export * from "./ProjectFolderDefaultTable.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectFolderDefaultTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports